import PropTypes from "prop-types";
import Grid2 from "@mui/material/Unstable_Grid2";
import MKTypography from "../../../components/MKTypography";
import MKBox from "../../../components/MKBox";

// SectionCard: The container of each section in home page, contains title, description, and children component.
const SectionCard = ({ children, title, description }) => (
  <MKBox
    px={{ lg: 2, xl: 4, xxl: 6, xxxl: 12 }}
    sx={{
      py: 3,
      backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
        `${linearGradient(rgba(gradients.light.state, 0.6), rgba(gradients.light.main, 1))}`,
      // backgroundColor: bgColor,
      // backdropFilter: "saturate(200%) blur(30px)",
      border: 0,
      borderRadius: 0,
    }}
  >
    <Grid2 container>
      <Grid2
        xs={10}
        lg={10}
        flexDirection="column"
        alignItems="center"
        sx={{
          mx: "auto",
          my: 1,
        }}
      >
        <MKBox>
          <MKTypography textAlign="center" variant="h2" fontWeight="bold" mb={1}>
            {title}
          </MKTypography>
          <MKTypography
            textAlign="justify"
            variant="body1"
            color="text"
            sx={({ breakpoints, typography: { size } }) => ({
              [breakpoints.up("xxl")]: {
                fontSize: size.xl,
              },
            })}
          >
            {description}
          </MKTypography>
        </MKBox>
      </Grid2>
      <Grid2 container xs={12}>
        {children}
      </Grid2>
    </Grid2>
  </MKBox>
);

SectionCard.defaultProps = {
  description: "Need description.",
  children: (
    <Grid2 container spacing={3} sx={{ width: 1, mt: 2 }}>
      Developing.
    </Grid2>
  ),
};

SectionCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};
export default SectionCard;
